/**
 * talk·point — Buybox-Button Lade-/Erfolgs-Zustand
 * Klick auf eine tp-Add-to-cart-Form -> .is-loading (Spinner). Beendet wird der
 * Lade-Zustand am SICHTBAREN Signal "Warenkorb-Drawer öffnet" (Primär), Hilfs-
 * signal "Cart-Badge ändert sich", und einem harten Notaus -> Laden hört IMMER
 * wieder auf. Erfolg -> .is-done (Checkmark-Burst), nach RESET_MS zurück zu Idle.
 * Der fliegende Schuss (Bild -> Warenkorb) kommt von Horizons <add-to-cart-component>
 * beim Klick (einziger Zeitpunkt, an dem das Cart-Icon noch nicht vom Drawer verdeckt ist).
 * Bewusst import-frei (kein Modul) -> keine Abhängigkeit von @shopify/events.
 */
(function () {
  if (window.__tpAtcInit) return;
  window.__tpAtcInit = true;

  var RESET_MS = 1500; // wie lange das Häkchen stehen bleibt
  var SAFETY_MS = 6000; // Notaus: Spinner spätestens hier beenden
  var current = null; // { btn, timer }

  function finish(success) {
    if (!current) return;
    var btn = current.btn;
    clearTimeout(current.timer);
    btn.classList.remove('is-loading');
    if (success) {
      btn.classList.add('is-done');
      setTimeout(function () {
        btn.classList.remove('is-done');
      }, RESET_MS);
    }
    current = null;
  }

  // START: Submit einer tp-Buybox (Capture, läuft vor Horizons handleSubmit).
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement) || form.getAttribute('data-type') !== 'add-to-cart-form') return;
      var btn = form.querySelector('.tp-pdp__cta');
      if (!btn || btn.disabled) return;
      if (current) finish(false); // evtl. alten Lauf hart beenden
      btn.classList.remove('is-done');
      btn.classList.add('is-loading');
      current = { btn: btn, timer: setTimeout(function () { finish(false); }, SAFETY_MS) };
    },
    true
  );

  // ENDE: der Cart-Drawer-INHALT re-rendert bei JEDEM Add (egal ob der Drawer
  // schon offen war oder gerade erst aufgeht). #cart-drawer ist stabil
  // (data-skip-node-update) -> der Subtree-Observer überlebt Section-Re-Renders
  // und feuert auch beim 2., 3., … Add. Plus das [open]-Attribut als Trigger.
  // Guard: greift nur wenn ein Lade-Zustand aktiv ist (`current`).
  var drawer = document.getElementById('cart-drawer');
  if (drawer) {
    new MutationObserver(function () {
      if (current) finish(true);
    }).observe(drawer, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['open'],
    });
  }

  // ── Selbstheilung: Drawer-Inhalt nach jedem Add gegen /cart.js abgleichen ──
  // Horizons Add-Flow rendert den Drawer über die Section Rendering API. Schlägt
  // das fehl (lokaler `shopify theme dev` liefert die Inline-Section sporadisch
  // leer; der Fallback `?section_id=` zieht zudem die Such-Tracking-Params
  // _pos/_sid/_ss aus window.location und läuft dann auf 404), bleibt der Drawer
  // stehen. Wir prüfen daher nach jedem Add, ob der Drawer den echten Warenkorb
  // zeigt – und holen den Inhalt sonst über den robusten Plural-Endpoint
  // (?sections=, saubere URL ohne Query) nach. Im Prod-Fall (native Render hat
  // geklappt) ist nichts „stale" → No-op, kein Flackern.
  var RECONCILE_DELAY_MS = 300; // kurz warten, damit der native Render (prod) zuerst greift
  var RECONCILE_RETRIES = 5; // Dev-Server ist eventually-consistent -> mehrere Pässe bis synchron

  function realRows() {
    var d = document.getElementById('cart-drawer');
    if (!d) return [];
    return Array.prototype.slice.call(d.querySelectorAll('tr.cart-items__table-row[id^="CartItem"]'));
  }

  function isStale(cart) {
    var rows = realRows();
    if (cart.item_count > 0 && rows.length === 0) return true; // leerer Drawer, voller Cart
    var drawerKeys = rows
      .map(function (r) { return r.getAttribute('data-key'); })
      .filter(Boolean)
      .sort()
      .join('|');
    var cartKeys = cart.items
      .map(function (i) { return i.key; })
      .sort()
      .join('|');
    if (drawerKeys !== cartKeys) return true; // andere/neue Zeile(n)
    // Mengen-Abgleich (fängt „gleicher Artikel erneut" = qty+1 ab)
    var drawerQty = rows.reduce(function (sum, r) {
      var inp = r.querySelector('input[type="number"],input[inputmode="numeric"],input[name="updates[]"],input[data-cart-quantity]');
      return sum + (inp ? parseInt(inp.value, 10) || 0 : 0);
    }, 0);
    if (drawerQty && drawerQty !== cart.item_count) return true;
    return false;
  }

  function refreshDrawerInner() {
    // Quelle = VOLLE aktuelle Seite (nicht die Section Rendering API): Der lokale
    // `shopify theme dev` liefert ?sections=/?section_id= für cart-drawer-section
    // unzuverlässig (mal Inhalt, mal null/leer). Das vollständige Seiten-Render
    // enthält den Drawer dagegen IMMER mit echtem Warenkorb-Stand (server-seitig
    // bei jedem Load gerendert) — robust auf dev UND prod. Läuft nur als Fallback,
    // wenn der native Render den Drawer nicht aktualisiert hat. cache:no-store +
    // Cache-Bust, sonst liefert der Browser eine veraltete Seite (Add-Lag).
    function attempt(left) {
      var url = window.location.pathname + '?_tp=' + Date.now();
      return fetch(url, { cache: 'no-store' })
        .then(function (r) { return r.text(); })
        .then(function (text) {
          if (!text || text.length < 100) throw new Error('empty page');
          var frag = new DOMParser().parseFromString(text, 'text/html');
          var freshInner = frag.querySelector('#cart-drawer .cart-drawer__inner') || frag.querySelector('.cart-drawer__inner');
          var liveInner = document.querySelector('#cart-drawer .cart-drawer__inner');
          if (!freshInner) throw new Error('no inner in page');
          if (liveInner) liveInner.replaceWith(freshInner);
        })
        .catch(function () {
          if (left > 0) return new Promise(function (res) { setTimeout(res, 300); }).then(function () { return attempt(left - 1); });
        });
    }
    return attempt(1);
  }

  // Prüft gegen den echten Warenkorb; ist der Drawer veraltet, Inhalt nachladen
  // und danach erneut prüfen (max. `left` Wiederholungen) — fängt langsame/
  // verspätete Section-Fetches auf dem Dev-Server ab, bis der Drawer synchron ist.
  function reconcile(left) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!isStale(cart)) return;
        return refreshDrawerInner().then(function () {
          if (left > 0) return new Promise(function (res) { setTimeout(res, 350); }).then(function () { return reconcile(left - 1); });
        });
      })
      .catch(function () {});
  }

  var reconcileTimer = null;
  function scheduleReconcile() {
    clearTimeout(reconcileTimer);
    reconcileTimer = setTimeout(function () { reconcile(RECONCILE_RETRIES); }, RECONCILE_DELAY_MS);
  }

  // An denselben Submit-Hook hängen wie der Lade-Zustand (Capture, vor Horizon).
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement) || form.getAttribute('data-type') !== 'add-to-cart-form') return;
      scheduleReconcile();
    },
    true
  );
})();
